export type PorcaoStatusColuna = "pending" | "done";

export type PorcaoColunaDef = {
  status: PorcaoStatusColuna;
  title: string;
  accentClass: string;
  badgeClass: string;
};

export const PORCAO_COLUNAS: PorcaoColunaDef[] = [
  {
    status: "pending",
    title: "Fila",
    accentClass: "border-amber-200 bg-amber-50",
    badgeClass: "bg-amber-200 text-amber-800",
  },
  {
    status: "done",
    title: "Finalizadas",
    accentClass: "border-emerald-200 bg-emerald-50",
    badgeClass: "bg-emerald-200 text-emerald-800",
  },
];
